import { z } from "zod";
import { $LOADER, $PAGE } from "~/util/Loaders";
import { getDiscordToken, getDiscordUser, findOrCreateUser } from "~/util/auth";
import { DiscordRegister } from "~/components/form/DiscordRegister";
import { redirect } from "react-router";
import { signIn } from "~/auth.server";
import {
  linkDiscordToUser,
  registerUserWithDiscord,
} from "~/lib/discord.server";
import { logPageView } from "~/util/stats";

const PageQuery = z.object({
  code: z.string().optional(),
  state: z.string().optional(),
});

$PAGE({
  path: "auth/discord",
  loader: $LOADER?.(async (cx) => {
    // Log
    logPageView(cx);
    //
    const query = PageQuery.parse(
      Object.fromEntries(cx.url.searchParams.entries())
    );
    const sess = cx.req.sess;

    const redirectUrl =
      (query.state && JSON.parse(decodeURIComponent(query.state)).from) ||
      "/profile";

    if (!query.code) throw new Error("Missing Discord code");
    try {
      const token = await getDiscordToken({
        code: query.code,
        realm: cx.realm,
      });
      const discordUser = await getDiscordUser(token.access_token);
      const result = await findOrCreateUser(discordUser);

      switch (result.t) {
        case "discord_exists":
          if (!sess) {
            await signIn(cx.res, result.userId);
          }
          return redirect(redirectUrl);
        case "match":
          if (!sess) {
            return { t: result.t, discordUser };
          }
        case "not_found":
          if (sess) {
            // Привязываем Discord к авторизованному пользователю
            await linkDiscordToUser({
              userId: sess.user.id,
              input: discordUser,
            });
            return redirect(redirectUrl);
          }
          // Если нет сессии, создаём нового пользователя
          const newUser = await registerUserWithDiscord({
            input: {
              login: discordUser.username,
              discordUser,
            },
          });
          await signIn(cx.res, newUser.data.userId);
          return redirect("/profile");
        default: {
          console.error("Unexpected result type:", result);
          throw new Error("Unexpected auth result");
        }
      }
    } catch (error) {
      if (error instanceof Error && error.message === "DISCORD_TOKEN_ERROR") {
        return redirect("/");
      }
      throw error;
    }
  }),

  meta: () => ({
    title: "Register - L2Hub.info",
    canonicalUrl: "/auth/discord",
  }),

  render: ({ data }) => {
    const { discordUser, t } = data;
    return (
      <div>
        <DiscordRegister discordUser={discordUser} />
      </div>
    );
  },
});
